// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b68Ac","content":"styles_content__2zahE","tableWrap":"styles_tableWrap__3EKAD"};